import rootReducer from '../reducers/rootReducer';

import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import loggerMiddleware from 'redux-logger';

const initialState = {};
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Middlewares only for development
const devMiddlewares = [];
if (process.env.NODE_ENV === 'development') {
  devMiddlewares.push(loggerMiddleware);
}


const configureStore = history => {
  return createStore(
    connectRouter(history)(rootReducer),
    initialState,
    composeEnhancer(
      applyMiddleware(
        routerMiddleware(history),
        thunkMiddleware,
        ...devMiddlewares,
        // Middlewares
      ),
    ),
  );
};

export default configureStore;


// WEBPACK FOOTER //
// ./src/store/store.js